var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.websiteId)?_c('appearance-form',{attrs:{"app-client-type-id":_vm.APP_CLIENT_TYPE_WEBSITE,"app-client-id":_vm.websiteId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }